import * as Businesses       from '../business';
import * as Contacts         from '../contacts';
import * as Device           from './device';
import * as ENV              from '../util/env';
import * as errors           from '../util/errors';
import * as Phone            from 'libphonenumber-js';
import * as UI               from '../ui';
import * as User             from '../user';
import { connect }           from 'react-redux';
import ms                    from 'ms';
import onChange              from '../util/on_change';
import React                 from 'react';
import rollbar               from '../rollbar';
import store                 from '../store';
import WithoutPaddingInViews from '../components/without_padding_in_views';


let customerOnCall;
let businessOnCall;

class CallBar extends React.PureComponent {

  constructor(props) {
    super(props);

    this.device                = null;
    this.isSettingDevice       = false;
    this.deviceUpdater         = null;
    this.connection            = null;
    this.state                 = CallBar.defaultState;
    this.bindUpdateOfDevice    = this.bindUpdateOfDevice.bind(this);
    this.unbindUpdateOfDevice  = this.unbindUpdateOfDevice.bind(this);
    this.handleOnConnection    = this.handleOnConnection.bind(this);
    this.handleOnDisconnect    = this.handleOnDisconnect.bind(this);
    this.handleIncoming        = this.handleIncoming.bind(this);
    this.handleOnFinish        = this.handleOnFinish.bind(this);
    this.handleOnMute          = this.handleOnMute.bind(this);
    this.handleOnDecline       = this.handleOnDecline.bind(this);
    this.handleOnAccept        = this.handleOnAccept.bind(this);
    this.handleConnectingCall  = this.handleConnectingCall.bind(this);
    this.connectDeviceIfNeeded = this.connectDeviceIfNeeded.bind(this);
  }

  async componentDidMount() {
    if (!this.canUseTwilio())
      return;

    const { device: deviceToUse } = this.props.callSettings;
    const useBrowserDevice        = deviceToUse === 'browser';

    if (useBrowserDevice)
      await this.connectDeviceIfNeeded();
    else
      document.addEventListener('connectingCall', this.handleConnectingCall);
  }

  async componentDidUpdate() {
    if (!this.canUseTwilio())
      return;

    const { device: deviceToUse } = this.props.callSettings;
    const useBrowserDevice        = deviceToUse === 'browser';
    if (useBrowserDevice)
      await this.connectDeviceIfNeeded();
  }

  canUseTwilio() {
    const isRegularUser  = !this.props.isSalesforce;
    const userIsSignedIn = this.props.isSignedIn;

    return (ENV.isWeb() && ENV.isWebRTCSupported()) && isRegularUser && userIsSignedIn;
  }

  async connectDeviceIfNeeded() {
    if (!this.isSettingDevice) {
      this.isSettingDevice = true;
      this.device          = await Device.getDevice();
      this.bindUpdateOfDevice();

      this.device.on('connect', this.handleOnConnection);
      this.device.on('cancel', this.handleOnDisconnect);
      this.device.on('disconnect', this.handleOnDisconnect);
      this.device.on('incoming', this.handleIncoming);
    }
  }

  bindUpdateOfDevice() {
    this.deviceUpdater = setInterval(() => {
      if (this.state.status === 'waiting')
        Device.updateToken().catch(rollbar.error);
    }, ms('5min'));
  }

  handleOnConnection(connection) {
    this.connection = connection;

    this.connection.on('error', error => {
      rollbar.error('Twilio call connection error', error);
    });
    this.setState({
      status:    'onCall',
      type:      this.state.type || 'outgoing',
      startedAt: new Date(),
      customer:  this.state.customer || customerOnCall,
      business:  this.state.business || businessOnCall
    });
    customerOnCall = null;
    businessOnCall = null;
  }

  handleOnDisconnect() {
    this.connection = null;
    if (this.state.customer && this.state.business)
      this.props.readContact({ customerID: this.state.customer.id, businessID: this.state.business.id });

    this.setState({ ...CallBar.defaultState });
  }

  async handleIncoming(connection) {
    const { status } = this.state;
    if (status !== 'waiting')
      return;

    this.connection         = connection;
    const businessID        = connection.customParameters.get('businessID');
    const customerID        = connection.customParameters.get('customerID');
    const isKnownCustomer   = businessID && customerID;
    const callerPhoneNumber = connection.parameters.From;
    const { readContact }   = this.props;
    const { readBusiness }  = this.props;

    if (isKnownCustomer) {
      const { getBusiness } = this.props;
      const { getContact }  = this.props;
      const business        = getBusiness(businessID);
      const customer        = getContact(customerID);

      const needToLoadData = !business && !customer;
      if (needToLoadData) {
        await readBusiness({ businessID });
        await readContact({ businessID, customerID });
      }
    }

    this.setState({
      type:   'incoming',
      status: 'ringing',
      isKnownCustomer,
      callerPhoneNumber,
      businessID,
      customerID
    });
  }

  handleConnectingCall({ detail }) {
    const { customer } = detail;
    const { business } = detail;
    const startedAt    = new Date();

    this.setState({
      type:   'connectingCall',
      status: 'onCall',
      startedAt,
      customer,
      business
    });


    onChange(store, state => Contacts.getContact(state, customer.id), (old, customerWithNewActivity, unsubscribe) => {
      if (!customerWithNewActivity)
        return;

      const lastActivity = customerWithNewActivity
        .activities
        .filter(({ type }) => type === 'Call')
        .pop();

      if (!lastActivity)
        return;

      const lastCallActivity = lastActivity.call;
      const isInProgress     = lastCallActivity.status === 'in-progress';
      if (isInProgress)
        return;

      const isStatusNewThanStartedAt = new Date(lastCallActivity.startedAt).getTime() > startedAt.getTime();
      if (isStatusNewThanStartedAt) {
        this.setState({
          ...CallBar.defaultState
        });
        unsubscribe();
      }
    });
  }

  componentWillUnmount() {
    this.unbindUpdateOfDevice();
    this.unbindConnectingCall();
  }

  unbindUpdateOfDevice() {
    clearInterval(this.deviceUpdater);
  }

  unbindConnectingCall() {
    document.removeEventListener('connectingCall', this.handleConnectingCall);
  }

  handleOnFinish() {
    this.connection.disconnect();
  }

  handleOnMute() {
    const { isMuted } = this.state;
    const mute        = !isMuted;

    this.connection.mute(mute);
    this.setState({ isMuted: mute });
  }

  handleOnAccept({ business, customer }) {
    this.connection.accept();

    this.setState({
      status:    'onCall',
      startedAt: new Date(),
      business,
      customer
    });
  }

  handleOnDecline() {
    this.connection.reject();
    this.connection = null;
    this.setState({
      ...CallBar.defaultState
    });
  }

  render() {
    const { status } = this.state;
    if (status === 'waiting')
      return null;

    const { customer }          = this.state;
    const { business }          = this.state;
    const { startedAt }         = this.state;
    const { isMuted }           = this.state;
    const { businessID }        = this.state;
    const { customerID }        = this.state;
    const { isKnownCustomer }   = this.state;
    const { callerPhoneNumber } = this.state;
    const { type }              = this.state;

    const componentProps = {
      customer,
      business,
      startedAt,
      isMuted,
      businessID,
      customerID,
      isKnownCustomer,
      callerPhoneNumber,
      type,
      handleOnFinish:  this.handleOnFinish,
      handleOnMute:    this.handleOnMute,
      handleOnAccept:  this.handleOnAccept,
      handleOnDecline: this.handleOnDecline
    };

    return (
      <WithoutPaddingInViews className="call__bar">
        {status === 'onCall' && (<OnCall {...componentProps}/>)}
        {type === 'incoming' && status === 'ringing' && (<IncomingCallContainer {...componentProps}/>)}
      </WithoutPaddingInViews>
    );
  }
}

CallBar.defaultState = {
  status:          'waiting', // ['waiting', 'onCall', 'ringing']
  type:            null, // ['incoming', 'outgoing']
  customer:        null,
  startedAt:       null,
  isMuted:         false,
  isKnownCustomer: false // When is a incoming call we check if we know the customer
};


function OnCall({ type, business, customer, callerPhoneNumber, startedAt, isMuted, handleOnFinish, handleOnMute }) {
  const displayName        = getDisplayNameOnCall({ type, business, customer, callerPhoneNumber });
  const displayControllers = type !== 'connectingCall';

  return (
    <div className="call__bar-container">
      <div className="call__bar-info">
        <div>{displayName}</div>
        <div>
          {startedAt && <Duration startedAt={startedAt}/>}
        </div>
      </div>
      {displayControllers && (
        <div className="button-container">
          <Mute onClick={handleOnMute} isMuted={isMuted}/>
          <End onClick={handleOnFinish}/>
        </div>
      )}
    </div>
  );
}

function getDisplayNameOnCall({ type, business, customer, callerPhoneNumber }) {
  const isIncoming = type === 'incoming';

  if (isIncoming) {
    const phoneNumber     = formatPhoneNumber(callerPhoneNumber);
    const isKnownCustomer = business && customer;

    if (isKnownCustomer)
      return (<DisplayNameWithLink customer={customer} business={business}/>);
    else
      return `Lead (${phoneNumber})`;
  } else
    return (<DisplayNameWithLink customer={customer} business={business}/>);
}

function DisplayNameWithLink({ customer, business }) {
  return (
    <React.Fragment>
      <a href={`/${business.id}/contacts/${customer.id}`}>
        {customer.name.full}
      </a>
      <br/>
      {business.name}
    </React.Fragment>
  );
}


function IncomingCall({ isKnownCustomer, callerPhoneNumber, business, customer, handleOnDecline, handleOnAccept }) {
  const isLead        = !isKnownCustomer;
  const hasDataLoaded = isKnownCustomer && business && customer;
  const phoneNumber   = formatPhoneNumber(callerPhoneNumber);

  return (
    <div className="call__bar-container">
      <div>
        <p>
          {isLead && `Lead ${phoneNumber}`}
          {isKnownCustomer && !hasDataLoaded && `Customer ${phoneNumber}`}
          {isKnownCustomer && hasDataLoaded && (<DisplayNameWithLink customer={customer} business={business}/>)}
        </p>
      </div>
      <div className="button-container">
        <Decline onClick={handleOnDecline}/>
        <Accept onClick={() => handleOnAccept({ business, customer })}/>
      </div>
    </div>
  );
}

function formatPhoneNumber(number) {
  return Phone.format(number, 'National');
}

const IncomingCallContainer = connect(
  (state, { business, customer, businessID, customerID }) => ({
    business: business || Businesses.getBusiness(state, businessID),
    customer: customer || Contacts.getContact(state, customerID)
  })
)(IncomingCall);



export async function callCustomer({ business, customer }) {
  store.dispatch(UI.progressStart());

  try {
    const { device: deviceToUse } = User.getCallSettings(store.getState());

    if (deviceToUse === 'phone') {
      const customerID = customer.id;

      await store.dispatch(Contacts.makeConnectingCall({ customerID, businessID: business.id }));
      const connectingCallEvent = new CustomEvent(
        'connectingCall',
        {
          detail:  { customer, business },
          bubbles: true
        }
      );
      document.dispatchEvent(connectingCallEvent);
    } else {
      const device   = await Device.getDevice();
      customerOnCall = customer;
      businessOnCall = business;

      await connectDeviceToCustomer({ device, customer });
    }
  } catch (error) {
    if (error.statusCode === 400) {
      // Typically just one error.
      const messages = error.body.errors.map(({ message }) => message).join(', ');
      store.dispatch(errors.showToastError(messages));
    } else
      throw error;
  } finally {
    store.dispatch(UI.progressEnd());
  }
}

async function connectDeviceToCustomer({ device, customer }) {
  const connection = device.connect({ customerID: customer.id });
  return new Promise(resolve => device.on('connect', () => resolve(connection)));
}


class Duration extends React.PureComponent {

  componentDidMount() {
    this.timer = setInterval(() => this.forceUpdate(), ms('1s'));
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  render() {
    const formated = differenceFormated(this.props.startedAt);
    return (
      <div className="call__bar__duration text-align-center">{formated}</div>
    );
  }
}


function differenceFormated(startedAt) {
  function format(value) {
    const valueStr = `${parseInt(value, 10)}`;
    if (valueStr.length === 1)
      return `0${valueStr}`;
    else
      return valueStr;
  }

  const diff = Date.now() - startedAt.getTime();
  if (diff >= ms('1s')) {
    const hours   = format(diff / (60 * 60 * 1000));
    const minutes = format((diff / (60 * 1000)) % 60);
    const seconds = format((diff / 1000) % 60);

    return `${hours}:${minutes}:${seconds}`;
  } else
    return '00:00:00';
}


function Mute({ onClick, isMuted }) {
  return (
    <button className="button" onClick={onClick}>{isMuted ? 'Unmute' : 'Mute'}</button>
  );
}


function End({ onClick }) {
  return (
    <button className="button button-fill color-red" onClick={onClick}>End</button>
  );
}


function Decline({ onClick }) {
  return (
    <button className="button button-fill color-red" onClick={onClick}>Decline</button>
  );
}


function Accept({ onClick }) {
  return (
    <button className="button button-fill color-green" onClick={onClick}>Accept</button>
  );
}


export default connect(
  state => ({
    isSalesforce: User.isSalesforce(state),
    isSignedIn:   User.isSignedIn(state),
    callSettings: User.getCallSettings(state),
    getBusiness:  businessID => Businesses.getBusiness(state, businessID),
    getContact:   customerID => Contacts.getContact(state, customerID)
  }),
  dispatch => ({
    readBusiness: ({ businessID }) => dispatch(Businesses.silentlyLoadBusiness(businessID)),
    readContact:  ({ businessID, customerID }) => dispatch(Contacts.silentlyReadContact(customerID, businessID))
  })
)(CallBar);
